var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgQradar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3125_32300)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M25.6886 28.7889C29.564 25.91 32 21.2595 32 16.0554C32 7.19723 24.8028 0 15.9446 0C7.19723 0 0 7.19723 0 16.0554C0 24.692 6.86505 31.7785 15.5017 32H32V28.7889H25.6886ZM3.43253 16.0554C3.43253 9.07958 9.07958 3.43253 16.0554 3.43253C23.0311 3.43253 28.6782 9.07958 28.6782 16.0554C28.6782 23.0311 23.0311 28.6782 16.0554 28.6782C9.07958 28.6782 3.43253 23.0311 3.43253 16.0554Z",
    fill: "#C4E86B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.5858 8.30445C21.5927 6.31137 19.046 5.2041 16.1671 5.2041C13.399 5.2041 10.7415 6.31137 8.74845 8.30445C4.65156 12.4013 4.65156 19.1557 8.74845 23.3633L8.9699 23.1418C8.52699 22.6989 6.42319 20.1522 6.42319 15.8339C6.42319 11.2941 9.74499 7.64009 14.9491 7.19718C15.2813 7.19718 15.7242 7.08645 16.0564 7.08645C18.3817 7.08645 20.4855 7.97227 22.1464 9.63317C25.4682 13.0657 25.4682 18.7128 22.1464 22.1453L23.4751 23.3633C27.6827 19.1557 27.6827 12.4013 23.5858 8.30445Z",
    fill: "#C4E86B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.3684 10.5192C20.0397 9.07977 18.1574 8.30469 16.275 8.30469C14.2819 8.30469 12.5103 9.07977 11.1816 10.5192C8.41343 13.3981 8.41343 18.0486 11.1816 20.9275L11.5138 20.5953C10.4065 19.3774 9.85287 17.7165 9.85287 16.0556C9.85287 12.623 12.5103 9.85486 15.9428 9.85486C19.7075 9.85486 22.2543 12.7338 22.0328 16.0556C21.9221 17.1628 21.3684 18.4915 20.3719 19.5988L21.5899 20.8168C24.1366 18.1594 24.1366 13.3981 21.3684 10.5192Z",
    fill: "#C4E86B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.1548 12.844C18.3797 12.0689 17.3832 11.626 16.2759 11.626C15.1686 11.626 14.1721 12.0689 13.397 12.844C11.8468 14.3941 11.8468 17.0516 13.397 18.6018L13.7292 18.2696C13.1756 17.7159 12.7326 16.8301 12.7326 15.8336C12.7326 14.062 14.0614 12.6225 15.6115 12.6225C16.9403 12.6225 18.0475 13.6191 18.3797 14.837C18.4904 15.0585 18.4904 15.1692 18.4904 15.3907C18.4904 15.5014 18.4904 15.6121 18.4904 15.7229C18.4904 16.3872 18.3797 16.9409 18.0475 17.3838L19.0441 18.3803C20.705 17.0516 20.705 14.5049 19.1548 12.844Z",
    fill: "#C4E86B"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3125_32300"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgQradar);
export default __webpack_public_path__ + "static/media/Qradar.5f8bf7a404ed42d787696bf65ef9d115.svg";
export { ForwardRef as ReactComponent };